import { jsx as _jsx } from "react/jsx-runtime";
import { useAskInputCometTabs } from '#pplx/frontend/apps/ask/ask-input/ask-input-attributions/hooks/useAskInputCometTabs.js';
import { useAttachedTabsBadge } from '#pplx/frontend/apps/ask/ask-input/ask-input-attributions/hooks/useAttachedTabsBadge.js';
import { AskInputPlusMenuTabs } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/components/AskInputPlusMenuTabs.js';
import { AttachedTabsBadge } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/components/AttachedTabsBadge.js';
import { createPluginFactory } from '#pplx/frontend/composer-sdk/plugins/createPluginFactory.js';
import { useMemo } from 'react';
const cometTabsPickerPluginFactory = createPluginFactory({
    name: 'discover-article-comet-tabs-picker',
    capabilities: [
        {
            kind: 'plusMenu',
            items: async () => [
                {
                    id: 'comet-tabs',
                    render: ({ props }) => _jsx(AskInputPlusMenuTabs, { ...props }),
                },
            ],
        },
    ],
});
const attachedTabsBadgePluginFactory = createPluginFactory({
    name: 'discover-article-attached-tabs-badge',
    capabilities: [
        {
            kind: 'slot',
            components: [{ slot: 'leftAttribution', component: AttachedTabsBadge }],
        },
    ],
});
/** Reuses Ask tab eligibility and attachment state for Composer controls. */
export function useCometTabsPlugins() {
    const cometTabs = useAskInputCometTabs();
    const attachedTabsBadge = useAttachedTabsBadge();
    const pickerPlugin = useMemo(() => cometTabs.showCometTabs
        ? cometTabsPickerPluginFactory({
            attachedTabs: cometTabs.attachedTabs,
            onAddTab: cometTabs.onAddTab,
            onRemoveTab: cometTabs.onRemoveTab,
        })
        : undefined, [cometTabs]);
    const badgePlugin = useMemo(() => attachedTabsBadge.showAttachedTabsBadge
        ? attachedTabsBadgePluginFactory({
            tabs: attachedTabsBadge.tabs,
            onAddTab: attachedTabsBadge.onAddTab,
            onRemoveTab: attachedTabsBadge.onRemoveTab,
        })
        : undefined, [
        attachedTabsBadge.onAddTab,
        attachedTabsBadge.onRemoveTab,
        attachedTabsBadge.showAttachedTabsBadge,
        attachedTabsBadge.tabs,
    ]);
    return useMemo(() => ({ pickerPlugin, badgePlugin }), [pickerPlugin, badgePlugin]);
}
//# sourceMappingURL=useCometTabsPlugins.js.map